import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import MobileDrawer from "./MobileDrawer";
import MobileBottomNav from "./MobileBottomNav";
import CommandPalette from "./CommandPalette";

const COLLAPSED_KEY = "crm-sidebar-collapsed";

export default function AppShell({
  children,
  topbarProps = {},
  hideBottomNav = false,
  contentClassName = "",
}) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(COLLAPSED_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSED_KEY, collapsed ? "1" : "0");
    } catch {}
  }, [collapsed]);

  return (
    // overflow-x-hidden on the outer flex avoids horizontal jitter when a
    // child (chart, sticky topbar, dialog overlay) momentarily overshoots
    // by 1px during scroll — that jitter was being reported as a "white
    // space at the top during scroll" (BUG-02).
    <div className="flex min-h-screen overflow-x-hidden bg-background text-foreground">
      <Sidebar
        collapsed={collapsed}
        onToggleCollapsed={() => setCollapsed((c) => !c)}
      />

      <MobileDrawer open={mobileOpen} onOpenChange={setMobileOpen} />

      <CommandPalette onAddLead={topbarProps.onAddLead} />

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar
          {...topbarProps}
          onOpenMobileMenu={() => setMobileOpen(true)}
        />

        {/* min-h-0 prevents the flex child from refusing to shrink, which
            otherwise leaves a tall empty area when content is shorter than
            the viewport. Combined with overflow-x-hidden above, eliminates
            the "scroll into nothing" feel reported in BUG-02. */}
        <main className={`min-h-0 flex-1 pb-[60px] lg:pb-0 ${contentClassName}`}>
          {children}
        </main>

        {!hideBottomNav && <MobileBottomNav />}
      </div>
    </div>
  );
}
